module.exports = __webpack_public_path__ + "img/wallet.c5f3ac74.svg";